export type BreadcrumbItem = {
  type: (typeof BREADCRUMB_TYPE)[keyof typeof BREADCRUMB_TYPE];
  key: string;
  label?: string;
  to?: string;
  icon?: string;
};

export const BREADCRUMB_TYPE = {
  STATIC: 'static',
  WORKSTREAM: 'workstream',
  PLOT: 'plot',
  PLOT_GROUP: 'plotGroup',
} as const;
